// Redux Type Constants
export const COMMON = {
  USER_LOADED: 'USER_LOADED',
  PAGE_LOADED: 'PAGE_LOADED',
  SET_ADD_FLIGHT_OPEN: 'SET_ADD_FLIGHT_OPEN',
  SET_EDIT_FLIGHT_OPEN: 'SET_EDIT_FLIGHT_OPEN',
  SET_REQUEST_DETAILS_OPEN: 'SET_REQUEST_DETAILS_OPEN',
}
